import React from 'react'

const AdminCategories = () => {
  return (
    <div>Admin Categories Pages</div>
  )
}

export default AdminCategories